import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";

import Layout from "./components/Layout";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import GramsevakPage from "./pages/GramsevakPage";
import Gallery from "./pages/Gallery";
import JanmDakhala from "./pages/JanmDakhala";
import MrutDakhala from "./pages/MrutDakhala";
import VivahDakhala from "./pages/VivahDakhala";
import Namuna from "./pages/Namuna";
import VikasKame from "./pages/VikasKame";
import MeetingInfo from "./pages/MeetingInfo";
import RTIInfo from "./pages/RTIInfo";


import GramsevakServiceBook from './pages/GramsevakServiceBook';
import SarpanchKaryalaya from "./pages/SarpanchKaryalaya";
import UpSarpanchKaryalaya from "./pages/UpSarpanchKaryalaya";
import Contact from "./pages/Contact";
import GrampanchayatInfo from "./pages/GrampanchayatInfo";

import GPTeam from "./pages/GPTeam";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Namuna9 from "./pages/Namuna9";
import AndajPatrak from "./pages/AndajPatrak";


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
            <Route path="/Header" element={<Header />} />
             <Route path="/Footer" element={<Footer />} />
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/gramsevakpage" element={<GramsevakPage />} />
          <Route path="/gallery" element={<Gallery />} />
           <Route path="/janm-dakhala" element={<JanmDakhala />} />
           <Route path="/death" element={<MrutDakhala />} />
          <Route path="/vivah" element={<VivahDakhala />} />
          <Route path="/namuna" element={<Namuna/>}/>
          <Route path="/namuna9" element={<Namuna9/>}/>
            <Route path="/budget" element={<AndajPatrak/>}/>

          <Route path="/vikas" element={<VikasKame />} />
          <Route path="/sabha" element={<MeetingInfo />} />
          <Route path="/rti-info" element={<RTIInfo />} />
          <Route path="/info" element={<GrampanchayatInfo />} />
          <Route path="/team" element={<GPTeam />} />
        
          <Route path="/gramsevak" element={<GramsevakServiceBook />} />
          <Route path="/sarpanch" element={<SarpanchKaryalaya />} />
          <Route path="/upsarpanch" element={<UpSarpanchKaryalaya/>} />
          
          <Route path="/contact" element={<Contact />} />
        
         
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;

